// components/PrivacyPolicyContent.tsx
"use client";

import React from "react";
import styles from "@/app/blog/app.module.css";
import images from "../constants/images";
import appStyle from "../styles/app.module.css";

export default function PrivacyPolicyContent() {
  // Navigation component - only rendered on desktop
  // const Navigation = () => {
  //   if (isMobile) return null;

  //   return (
  //     <div className="w-[317px] sticky h-fit px-4 py-8 top-8">
  //       <nav className={styles.nav}>
  //         <ul className="m-0 p-0 list-none">
  //           {[
  //             { id: "introduction", text: "Introduction" },
  //             { id: "information-collection", text: "Information We Collect" },
  //             { id: "information-use", text: "How We Use Your Information" },
  //             { id: "information-sharing", text: "Sharing Your Information" },
  //             { id: "security", text: "Security of Your Information" },
  //             { id: "your-rights", text: "Your Rights" },
  //             { id: "children", text: "Children's Privacy" },
  //             { id: "changes", text: "Changes to This Privacy Policy" },
  //           ].map((item, index, array) => {
  //             const isActive = activeSection === item.id;
  //             const isLastItem = index === array.length - 1;

  //             return (
  //               <li
  //                 key={item.id}
  //                 className={isLastItem ? styles.navItemLast : styles.navItem}
  //               >
  //                 {/* Vertical bar */}
  //                 <span
  //                   className={`${styles.navBar} ${
  //                     isActive ? styles.navBarActive : styles.navBarInactive
  //                   }`}
  //                 />

  //                 {/* Dot */}
  //                 <span
  //                   className={`${styles.navDot} ${
  //                     isActive ? styles.navDotActive : styles.navDotInactive
  //                   }`}
  //                 />

  //                 <a
  //                   className={`${styles.navLink} ${
  //                     isActive ? styles.navLinkActive : styles.navLinkInactive
  //                   }`}
  //                   href={`#${item.id}`}
  //                 >
  //                   {item.text}
  //                 </a>
  //               </li>
  //             );
  //           })}
  //         </ul>
  //       </nav>
  //     </div>
  //   );
  // };

  return (
    <div className={appStyle.container}>
      <div className={styles.blogContent}>
        {/* Main content section */}
        <div>
          <h1>Privacy Policy</h1>
          <div>
            <p>
              Welcome to My Weddingly Invites! Your privacy is important to us.
              This Privacy Policy explains how we collect, use, disclose, and
              safeguard your information when you use our mobile application
              ("App"). By using the App, you agree to the collection and use of
              information in accordance with this policy.
            </p>
          </div>

          <h2>Information We Collect</h2>
          <p>We may collect and process the following types of information:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> This includes your name,
              email address, phone number, and any other information you provide
              when you create an account or contact us.
            </li>
            <li>
              <strong>Event Information:</strong> Details about the events you
              create, including dates, locations, guest lists, and any other
              event-related information.
            </li>
            <li>
              <strong>Usage Data:</strong> Information about how you use the
              App, such as the features you use and the time spent on the App.
            </li>
            <li>
              <strong>Device Information:</strong> Information about the device
              you use to access the App, including the device type, operating
              system, and unique device identifiers.
            </li>
          </ul>

          <h2>How We Use Your Information</h2>
          <p>We use the information we collect for the following purposes:</p>
          <ul>
            <li>
              <strong>To Provide and Maintain the App:</strong> To ensure the
              App functions properly and to deliver the services you request.
            </li>
            <li>
              <strong>To Improve the App:</strong> To understand how users
              interact with the App and make improvements.
            </li>
            <li>
              <strong>To Communicate with You:</strong> To send you updates,
              security alerts, and other information related to your use of the
              App.
            </li>
            <li>
              <strong>To Personalize Your Experience:</strong> To tailor the App
              to your preferences and enhance your user experience.
            </li>
          </ul>

          <h2>Sharing Your Information</h2>
          <p>
            We do not sell or rent your personal information to third parties.
            We may share your information in the following circumstances:
          </p>
          <ul>
            <li>
              <strong>With Your Consent:</strong> We may share your information
              with third parties if you give us your explicit consent.
            </li>
            <li>
              <strong>For Legal Reasons:</strong> We may disclose your
              information if required by law or in response to valid requests by
              public authorities.
            </li>
            <li>
              <strong>With Service Providers:</strong> We may share your
              information with third-party service providers who perform
              services on our behalf, such as hosting and data analysis.
            </li>
          </ul>

          <h2>Security of Your Information</h2>
          <p>
            We implement reasonable security measures to protect your
            information from unauthorized access, use, or disclosure. However,
            please be aware that no method of transmission over the internet or
            method of electronic storage is completely secure.
          </p>

          <h2>Your Rights</h2>
          <p>You have the following rights regarding your information:</p>
          <ul>
            <li>
              <strong>Access:</strong> You can request access to the information
              we hold about you.
            </li>
            <li>
              <strong>Correction:</strong> You can request that we correct any
              inaccuracies in your information.
            </li>
            <li>
              <strong>Deletion:</strong> You can request that we delete your
              information.
            </li>
            <li>
              <strong>Objection:</strong> You can object to the processing of
              your information.
            </li>
          </ul>

          <h2>Children's Privacy</h2>
          <p>
            The App is not intended for use by children under the age of 13. We
            do not knowingly collect personal information from children under
            13. If you are a parent or guardian and believe your child has
            provided us with personal information, please contact us, and we
            will take steps to delete such information.
          </p>

          <h2>Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy within the App.
            You are advised to review this Privacy Policy periodically for any
            changes.
          </p>
        </div>

        {/* Right navigation section - only on desktop */}
        {/* <Navigation /> */}
      </div>
    </div>
  );
}
